import axios from "axios"
import { env } from '../constants'

/* LOGIN ROUTE */
export const login = data => {
    const uri = `${env.startpoint}admin/login`
    return axios.post(uri, data).then(response => response).catch(data => data.response)
}
